import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectNotificationsData } from '../store/slices/notificationsSlice';
import { countByStatus } from './notificationStatus';
import './Notifications.css';

// Fetching lives in NotificationsContent, which owns the client/branch filters that
// decide what to fetch — dispatching here too would just double every request. The
// tiles read the same slice, so they describe whatever the filters are currently showing.
const NotificationsHeader = () => {
    const notificationsData = useSelector(selectNotificationsData);

    const stats = useMemo(() => {
        const active = countByStatus(notificationsData, 'Active');
        const inactive = countByStatus(notificationsData, 'Inactive');
        const read = notificationsData.reduce((sum, n) => sum + (Number(n.read_count) || 0), 0);
        const recipients = notificationsData.reduce((sum, n) => sum + (Number(n.recipient_count) || 0), 0);
        return {
            active,
            inactive,
            total: notificationsData.length,
            read,
            recipients,
            // No recipients means nothing could have been read — show 0%, not NaN.
            readPct: recipients > 0 ? Math.round((read / recipients) * 100) : 0
        };
    }, [notificationsData]);

    return (
        <div className="nf-hero">
            <div className="nf-hero-main">
                <div className="nf-hero-icon">
                    <i className="pi pi-bell" />
                </div>
                <div>
                    <h2 className="nf-hero-title">Notifications</h2>
                    <p className="nf-hero-sub">
                        Create and manage the alerts your clients see. Target a whole client or a single branch, set an expiry, and track who has read each one.
                    </p>
                </div>
            </div>

            <div className="nf-stats">
                <div className="nf-stat ok">
                    <div className="nf-stat-value">
                        <i className="pi pi-check-circle" />
                        {stats.active}
                    </div>
                    <div className="nf-stat-label">Active</div>
                </div>
                <div className="nf-stat err">
                    <div className="nf-stat-value">
                        <i className="pi pi-times-circle" />
                        {stats.inactive}
                    </div>
                    <div className="nf-stat-label">Inactive</div>
                </div>
                <div className="nf-stat read">
                    <div className="nf-stat-value">
                        <i className="pi pi-eye" />
                        {stats.readPct}%
                    </div>
                    {/* "Read Rate", not "Read" — there is now also a Read *status*, and
                        this tile is the share of recipients who have opened an alert. */}
                    <div className="nf-stat-label">Read Rate</div>
                    <div className="nf-progress">
                        <span style={{ width: `${stats.readPct}%` }} />
                    </div>
                </div>
                <div className="nf-stat all">
                    <div className="nf-stat-value">
                        <i className="pi pi-bolt" />
                        {stats.total}
                    </div>
                    <div className="nf-stat-label">Total</div>
                </div>
            </div>
        </div>
    );
};

export default NotificationsHeader;
